/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationsRequest {
    getFixupPrototypeFunction() { return ListRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationsRequest>): ListRecommendationsRequest {
        let obj = Object.assign(new ListRecommendationsRequest(), model);
        ListRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationsRequest>): ListRecommendationsRequest {
        if (!model) return null;
        return ListRecommendationsRequest.newInstance(<ListRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationsRequest) {
        if (!obj) return;

        models.ListRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ListRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page === undefined) {
            this.page = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * page number.Example 'page': 1
     */
    page: number;

    /**
     * records limits. Example 'limit': 10
     */
    limit: number;

    /**
     * Classifications based on OSCAR pillars. Accepted values: Operation, Security, Cost, Access, Resource
     */
    classification: string;

    /**
     * Sub-Classification based on the Classification selected.                                                                                                     Accepted Values:                                                                                                         \"Operation\": Performance, Availability, Standards, Logging, Monitoring                                                                                                         \"Security\": Data, Network, Host, Application, End Point protection, Standards                                                                                                         \"Cost\": Orphaned, Config, Idle, Underutilized, Anomaly, Billing, Budget, Overutilized, Optimized                                                                                                         \"Access\": Standards, Utilization                                                                                                         \"Resource\": Naming Standards, Tag Pattern, Locks
     */
    sub_classification: string;

    /**
     * Mention the Recommendation group. Accepted values: Policy, Advisor, Right-Size
     */
    recommendation_group: string;

    /**
     * Status. Acceptable values: open, resolved, skipped, system_skipped
     */
    status: string;

    /**
     * Specify the Cloud account ID. This can be retrieved from  List Cloud account API call.
     */
    cloud_account_id: string;

    /**
     * Cloud Service Name. Example: 'service_name': 'AWS'/'Azure'/'GCP'
     */
    service_name: string;

}
